<template>
  <strong class="Semibold"><slot></slot></strong>
</template>

<script>
export default {
  name: "SemiBold"
};
</script>

<style scoped>
.Semibold {
  font-weight: 600;
}
</style>
